import { Badge } from "@/components/Badge.tsx";
import { getPrimaryStorage } from "@/modules/compute/vmEntityUtils.ts";
import { label_GB_disk, label_GB_RAM } from "@/modules/l10n/units.tsx";
import type { MachineCommonFields } from "@/modules/pricing/resourcePricing.ts";
import { Trans } from "@lingui/react/macro";

export function MachineSizeInfo({ vm }: { vm: MachineCommonFields }) {
    const { vcpu, memory } = vm;

    const primary = getPrimaryStorage(vm);
    return (
        <div className="flex gap-0.25em flex-wrap">
            <Badge color="text">
                {vcpu} <Trans>vCPU</Trans>
            </Badge>
            <Badge color="text">
                {memory / 1024} {label_GB_RAM}
            </Badge>
            {primary && (
                <Badge color="text">
                    {primary.size} {label_GB_disk}
                </Badge>
            )}
        </div>
    );
}
